import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import { facilitySchema } from '../../../schemas'

export default function New({ account, accounts, navigation }) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="New Facility"
    >
      <BackLink href="/manage/facilities">Back to Facilities</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={facilitySchema}
          resource="facility"
          endpoint="/manage/facilities"
          backLink="/manage/facilities"
          submitLabel="Create Facility"
          defaultValues={{
            name: '',
            description: '',
            opening_hours: '',
            link: '',
            email: '',
            phone: '',
            header_image: null
          }}
        >
          {({ control, errors }) => (
            <>
              <FormFieldController
                control={control}
                name="name"
                label="Name"
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="description"
                label="Description"
                type="textarea"
                rows={2}
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="opening_hours"
                label="Opening Hours"
                placeholder="e.g., Mon-Fri 9am-5pm"
                errors={errors}
              />

              <div className="grid grid-cols-2 gap-4">
                <FormFieldController
                  control={control}
                  name="email"
                  label="Email"
                  type="email"
                  errors={errors}
                />
                <FormFieldController
                  control={control}
                  name="phone"
                  label="Phone"
                  errors={errors}
                />
              </div>

              <FormFieldController
                control={control}
                name="link"
                label="Website"
                type="url"
                placeholder="https://..."
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="header_image"
                label="Header Image"
                type="file"
                accept="image/*"
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
